<script setup lang="ts">
const {featuredArticles} = storeToRefs(useArticleStore());
const {getFeaturedArticles} = useArticleStore();
getFeaturedArticles();
</script>

<template>
  <section v-if="featuredArticles" class="articles bg-black w-full max-w-[2560px] mx-auto">
    <ul
      v-gsap.whenVisible.once.reversible.stagger.from="{
        scale: 0,
        stagger: 0.25,
        ease: 'Power3.out',
      }"
      class="grid grid-cols-3 gap-0 w-full m-0 p-0 text-white">
      <ArticlesFeatureItem v-for="article in featuredArticles" :key="article.slug" :article="article" />
    </ul>
  </section>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/queries';
.articles {
  ul {
    @include queries.for-size(tablet-landscape-down) {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
